export interface SaveDraftResponse {
    draftId: number;
    draftStatus: number;
    success: boolean;
}
